import { BaseRepository } from "@/repositories/base-repository"
import { type IInstruction } from "@/interfaces/api/instruction.interface"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"
import type { Instruction } from "@/models/instruction.model.ts"
import type { ODataQueryBuilder } from "@/builder/odata-query-builder.ts"
import type moment from "moment"

export class InstructionRepository extends BaseRepository<IInstruction> {
  protected resourcePath = "planning/instructions"

  public async getListForServiceProvider(
    serviceProvider: KnownBusinessEntityContact,
    query?: ODataQueryBuilder
  ) {
    const httpRequestBuilder = new HTTPRequestBuilder(
      HTTPMethods.GET,
      `planning/service-providers/${serviceProvider.id}/instructions/`
    )
    httpRequestBuilder.query(query)
    return httpRequestBuilder.build().execute()
  }

  public async generateSummaryTextSuggestion(instruction: Instruction) {
    const httpRequestBuilder = new HTTPRequestBuilder(
      HTTPMethods.PUT,
      `planning/instructions/${instruction.id}/suggest-summary-text/`
    )
    return httpRequestBuilder.build().execute()
  }

  /**
   * Clone a set of instructions to the given target date on the server.
   * The backend will create copies (clearing workflow/output fields) and,
   * for each source instruction whose `willRecurNextWorkday` is true,
   * set its `nextCopy` to point at the newly-created clone.
   */
  public async cloneToDate(instructionIds: string[], targetDate: moment.Moment) {
    const httpRequestBuilder = new HTTPRequestBuilder(
      HTTPMethods.POST,
      `planning/instructions/clone-to-date/`
    )
    httpRequestBuilder.setData({
      instruction_ids: instructionIds,
      target_date: targetDate.format("YYYY-MM-DD")
    })
    return httpRequestBuilder
      .setExpectedStatusCode(201)
      .anonymizeResultingWebsocketMessages()
      .build()
      .execute()
  }
}
